$(function() {
  // Dropdown toggle
  $('.dropdown-toggle').click(() => $('.dropdown-menu').toggle());
  $('.dropdown-menu li a').click(() => $('.dropdown-menu').hide());

  // Close dropdowns when clicking outside
  $(document).click(function(event) {
    if (!$(event.target).closest('.header_currency').length) {
      $('.header_currency .dropdown-menu').hide();
    }
    if (
      !$(event.target).closest('#header_search').length &&
      event.target.id !== 'header_search' &&
      !$(event.target).closest('#side_search').length &&
      event.target.id !== 'side_search'
    ) {
      $(".side_search").hide();
    }
    if (
      !$(event.target).is('.sign_in_box, .sign_in_box *, #header_accounts, #header_accounts *')
    ) {
      $(".sign_in_box").hide();
    }
  });

  // Scroll behavior
  function onScroll() {
    if ($(document).scrollTop() >= 12) {
      $(".main_header").fadeIn().css("background", "#fff");
      $(".mega_shop, .mega_best_sellers, .mega_about, .mega_quiz").hide();
    }
  }

  if ($(document).scrollTop() >= 12) {
    onScroll();
    $("#header_search img, #header_cart a").click(() => {
      $(".template-index .main_header").fadeIn().css("background", "#fff");
    });
  }

  $(document).scroll(onScroll);

  // Header account toggle
  $('#header_accounts').click(() => $('.sign_in_box').toggle());

  // Shopify cart item update
  Shopify.onItemAdded = function() {
    $.getJSON('/cart.js', cart => {
      $('#cart_counter').html(cart.item_count);
    });
  };

  // Hamburger menu toggle
  $('#hamburger').click(function() {
    $(this).toggleClass('open');
    $(".mobile_menu").fadeToggle();
    $("#header_bar").fadeIn(10000).toggleClass("active_menu");
    $("html").toggleClass("prevent_x_scroll");
    $(".main_header").toggleClass("white_bg");
    $("body").toggleClass('ham_open');
    $("#cover_page_nav").fadeToggle();
  });

  $('#cover_page_nav').click(function() {
    $(this).hide();
    $("html").removeClass("prevent_x_scroll");
    $(".main_header").removeClass("white_bg");
  });

  $('#header_search img, #header_cart img').click(function() {
    $("#hamburger").removeClass('open');
    $(".mobile_menu").fadeOut();
    $("#header_bar").addClass("active_menu");
    $(".main_header").removeClass("white_bg");
    $("body").removeClass('ham_open');
  });

  // Set first tab active
  $("ul#tabs-titles li:first-child").addClass("current");

  // Mega menu hover effects
  function resetNav() {
    $("#main_nav_shop, #main_nav_best, #main_nav_about, #main_nav_quiz").removeClass("green_underline");
    $(".mega_shop, .mega_best_sellers, .mega_about, .mega_quiz").hide();
    $("#header_bar").removeClass("active_menu active_menu2 active_menu3");
  }

  $("li#main_nav_shop").mouseover(function() {
    resetNav();
    $(this).addClass("green_underline");
    $(".mega_shop").toggle();
    $("#header_bar").toggleClass("active_menu");
    $(".main_header").css("background", "#fff");
  });

  $("li#main_nav_best").mouseover(function() {
    resetNav();
    $(this).addClass("green_underline");
    $(".mega_best_sellers").toggle();
    $("#header_bar").toggleClass("active_menu2");
    $(".main_header").css("background", "#fff");
  });

  $("li#main_nav_about").mouseover(function() {
    resetNav();
    $(this).addClass("green_underline");
    $(".mega_about").toggle();
    $("#header_bar").toggleClass("active_menu3");
    $(".main_header").css("background", "#fff");
  });

  $("li#main_nav_quiz").mouseover(function() {
    resetNav();
    $(this).addClass("green_underline");
    $(".mega_quiz").toggle();
    $("#header_bar").toggleClass("active_menu3");
    $(".main_header").css("background", "#fff");
  });

  $(document).mouseover(function(e) {
    if (!$(e.target).closest('#shopify-section-header').length) {
      resetNav();
    }
  });

  // Header spacing
  function updateHeaderSpacing() {
    const topBarHeight = $(".top_bar").innerHeight();
    const headerHeight = $(".main_header").innerHeight();
    const totalHeadHeight = topBarHeight + headerHeight;

    $("#header_bar").css("margin-top", topBarHeight);
    $(".main").css("padding-top", totalHeadHeight);
    $(".template-index .main, .template-blog .main, .template-article .main, #our-story .main")
      .css("padding-top", topBarHeight);
    $(".mobile_menu").css({
      "margin-top": topBarHeight,
      "padding-top": headerHeight
    });
  }

  updateHeaderSpacing();
  $(window).resize(() => {
    updateHeaderSpacing();

    if ($(window).width() >= 929) {
      $(".main_header").removeClass("white_bg");
      $("html").removeClass("prevent_x_scroll");
      if ($(".mobile_menu").is(":visible")) {
        $(".mobile_menu").hide();
        $("#hamburger").removeClass('open');
        $(".header_bar").removeClass("active_menu");
      }
    }

    if ($(window).width() <= 929) {
      resetNav();
    }
  });

  // Tabs hover
  const tabs = $('#tabs-titles li');
  const contents = $('#tabs-contents li');
  tabs.mouseover(function () {
    const index = $(this).index();
    tabs.removeClass('current');
    contents.hide().eq(index).show();
    $(this).addClass('current');
  });
});
